import { ReactComponent as camera } from "./camera.svg";
import { ReactComponent as female } from "./female.svg";
import { ReactComponent as male } from "./male.svg";
import { ReactComponent as phone } from "./phone.svg";
import { ReactComponent as location } from "./location.svg";
import { ReactComponent as tag } from "./tag.svg";
import { ReactComponent as close } from "./close.svg";
import { ReactComponent as arrow } from "./arrow.svg";
import { ReactComponent as arrowLeft } from "./arrowLeft.svg";
import { ReactComponent as arrowUp } from "./arrowUp.svg";
import { ReactComponent as exclamation } from "./exclamation.svg";
import { ReactComponent as question } from "./question.svg";
import { ReactComponent as search } from "./search.svg";
import { ReactComponent as place } from "./place.svg";
import { ReactComponent as smallLogo } from "./LeumitSmallLogo.svg";
import { ReactComponent as arrowLeftPurple } from "./arrowLeftPurple.svg";
import { ReactComponent as arrowUpPurple } from "./arrowUpPurple.svg";
import { ReactComponent as arrowLeftBlue } from "./arrowLeftBlue.svg";
import { ReactComponent as filter } from "./filter.svg";
import { ReactComponent as arrowDownBlue } from "./arrowDownBlue.svg";
import { ReactComponent as emergency} from "./emergency.svg";
import { ReactComponent as optica} from "./Optica.svg";
import { ReactComponent as teeth} from "./teeth.svg";
import { ReactComponent as womenEmergency} from "./womenEmergency.svg";
import { ReactComponent as outerService} from "./outerService.svg";
import { ReactComponent as magnifier } from "./magnifier.svg";
import { ReactComponent as icon } from "./icon.svg";
import { ReactComponent as bannerPhone } from "./bannerPhone.svg";
import { ReactComponent as arrowDownWhite } from "./arrowDownWhite.svg";
import { ReactComponent as tagRequired } from "./tagRequired.svg";
import { ReactComponent as goldZakautChecked } from "./goldZakautChecked.svg";
import { ReactComponent as goldZakaut } from "./goldZakaut.svg";
import { ReactComponent as salZakautChecked } from "./salZakautChecked.svg";
import { ReactComponent as salZakaut } from "./salZakaut.svg";
import { ReactComponent as silverZakaut } from "./silverZakaut.svg";
import { ReactComponent as silverZakautChecked } from "./silverZakautChecked.svg";
import { ReactComponent as zakautDisable } from "./zakautDisable.svg";
import { ReactComponent as medicalCenter } from "./medicalCenter.svg";
import { ReactComponent as gold } from "./gold.svg";
import { ReactComponent as silver } from "./silver.svg";
import { ReactComponent as basic } from "./basic.svg";
import { ReactComponent as arrowLeft2 } from "./arrowLeft2.svg";
import { ReactComponent as arrowUp2 } from "./arrowUp2.svg";

export const Camera = camera;
export const ArrowDownWhite = arrowDownWhite;
export const BannerPhone = bannerPhone;
export const ArrowLeft2 = arrowLeft2;
export const ArrowUp2 = arrowUp2;
export const Basic = basic;
export const Silver = silver;
export const Icon = icon;
export const Phone = phone;
export const Location = location;
export const Female = female;
export const Male = male;
export const Tag = tag;
export const Close = close;
export const Arrow = arrow;
export const ArrowLeft = arrowLeft;
export const ArrowUp = arrowUp;
export const Exclamation = exclamation;
export const Question = question;
export const Search = search;
export const Place = place;
export const SmallLogo = smallLogo;
export const ArrowLeftPurple = arrowLeftPurple;
export const ArrowUpPurple = arrowUpPurple;
export const ArrowLeftBlue = arrowLeftBlue;
export const Filter = filter;
export const ArrowDownBlue = arrowDownBlue;
export const Emergency = emergency;
export const Optica = optica;
export const Teeth = teeth;
export const WomenEmergency = womenEmergency;
export const OuterService = outerService;
export const Magnifier = magnifier;
export const Gold = gold;
export const TagRequired = tagRequired;
export const GoldZakautChecked = goldZakautChecked;
export const SalZakautChecked = salZakautChecked;
export const SilverZakaut = silverZakaut;
export const ZakautDisable = zakautDisable;
export const GoldZakaut = goldZakaut;
export const SilverZakautChecked = silverZakautChecked;
export const SalZakaut = salZakaut;
export const MedicalCenter = medicalCenter;
export const Operation = Male;



declare global {
    interface Window {
        ICONS_doctorSearchResults: any;
        ICONS_doctorsSearch: any; 
        ICONS_medicalCenterSearchResults: any;   
        ICONS_OperationsSearchResults: any;
        ICONS_medicineSearchResults: any;
        ICONS_zakautSearchResults: any;
        ICONS_outerServicesSearchResults: any;
    }
}
